import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import {
  Primary12SemiBold,
  SequenceMenu,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'
import { useState } from 'react'

const MarkAsSentInvoiceModal = (props: {
  invoiceId: string
  onSuccess?: () => void
  onClose: () => void
}) => {
  const { displayNotification } = useNotifications()

  const markAsSentMutation = useMutation(
    dashboard20240730Client.postMarkAsSentInvoice,
    {
      onSuccess: () => {
        displayNotification('Invoice marked as sent', {
          type: 'success'
        })
      },
      onError: () => {
        displayNotification('Failed to mark invoice as sent', {
          type: 'error'
        })
      }
    }
  )

  return (
    <SimpleModal
      data-testid="invoices.markAsSentInvoice.modal"
      variant="dialog"
      title="Mark invoice as sent"
      submitButtonText="Mark invoice as sent"
      submittingButtonText="Marking invoice as sent..."
      isOpen
      onClose={props.onClose}
      onSubmit={async () => {
        await markAsSentMutation.mutateAsync({ id: props.invoiceId })
        props.onSuccess?.()
        return true
      }}
    >
      This marks the invoice as{' '}
      <span style={{ fontWeight: Primary12SemiBold.fontWeight }}>Sent</span>. No
      email will be sent and the invoice will not automatically sync to your
      connectors. You will no longer be able to edit this invoice. This action
      cannot be undone.
    </SimpleModal>
  )
}

export const MarkAsSent = (props: {
  invoiceId: string
  invoiceNumber: string | undefined
  onSuccess?: () => void
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { can } = usePermissions()

  if (!can('org.invoice:update')) {
    return null
  }

  return (
    <>
      <SequenceMenu.Item
        data-testid="invoices.markAsSent.menuItem"
        uuid="mark-as-sent"
        label="Mark invoice as sent"
        onClick={e => {
          e.stopPropagation()
          setIsOpen(true)
        }}
      />
      {isOpen && (
        <MarkAsSentInvoiceModal
          invoiceId={props.invoiceId}
          onSuccess={props.onSuccess}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
